import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import { IvrFlow } from '../types';

type FlowSelectorProps = {
    flows: IvrFlow[];
    selectedFlow: IvrFlow | null;
    onFlowChange: (flow: IvrFlow | null) => void;
    disabled?: boolean;
};

export default function FlowSelector({ flows, selectedFlow, onFlowChange, disabled }: FlowSelectorProps) {
    return (
        <Box>
            <Typography sx={{ color: '#334155', fontSize: '12px', fontWeight: 500, lineHeight: '14px', marginBottom: '4px' }}>
                Select IVR Flow
            </Typography>
            <Autocomplete
                options={flows}
                value={selectedFlow}
                size="small"
                disabled={disabled}
                onChange={(_, value) => onFlowChange(value)}
                getOptionLabel={(option) => option.flowName ?? ''}
                isOptionEqualToValue={(option, value) => option.flowId === value.flowId}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Select a flow"
                        size="small"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                )}
                renderOption={(props, option) => (
                    <Box component="li" {...props}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#0f172a' }}>
                            {option.flowName}
                        </Typography>
                    </Box>
                )}
            />
        </Box>
    );
}
